import {
    LEAD_PLANS_FETCH,
    LEAD_PLANS_FETCH_FAILED,
    LEAD_PLANS_FETCH_SUCCEEDED,
    MONETARY_PLANS_FETCH,
    MONETARY_PLANS_FETCH_FAILED,
    MONETARY_PLANS_FETCH_SUCCEEDED,
    SMS_PLANS_FETCH_SUCCEEDED,
    WHATSAPP_PLANS_FETCH_SUCCEEDED
} from "../../constants/ActionTypes";

const initialState = {
    sms: [],
    monetary: [],
    lead: [],
    whatsapp: [],
    // Billing shows placeholders while these load.
    monetaryLoading: false,
    leadLoading: false
};

const plans = (state = initialState, action) => {
    switch (action.type) {
        case SMS_PLANS_FETCH_SUCCEEDED:
            return {
                ...state,
                sms: [...action.plans],
            };
        case WHATSAPP_PLANS_FETCH_SUCCEEDED:
            return {
                ...state,
                whatsapp: [...action.plans],
            };
        case MONETARY_PLANS_FETCH:
            return {...state, monetaryLoading: true};
        case MONETARY_PLANS_FETCH_FAILED:
            return {...state, monetaryLoading: false};
        case MONETARY_PLANS_FETCH_SUCCEEDED:
            return {
                ...state,
                monetary: [...action.plans],
                monetaryLoading: false
            };
        case LEAD_PLANS_FETCH:
            return {...state, leadLoading: true};
        case LEAD_PLANS_FETCH_FAILED:
            return {...state, leadLoading: false};
        case LEAD_PLANS_FETCH_SUCCEEDED:
            return {
                ...state,
                lead: [...action.plans],
                leadLoading: false
            };
        default:
            return state;
    }
};

export default plans;
